import { Injectable } from '@angular/core';
import { MatDialogModule as MatDialogModule } from '@angular/material/dialog';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { PDLService } from 'src/app/services/pdl-service.service';
import { ANALYTICS } from '../core/common.constants';
import { AlertConfirmPopupComponent } from './alert-confirm-popup.component';
import { AlertConfigData } from './index';
import { ModalPromise } from './promise';

@Injectable({
  providedIn: 'root',
})
export class AlertConfirmPopupService {
  isModalOpen: any;
  ngbModalOptions: NgbModalOptions;

  constructor(public dialog: MatDialogModule, private modalService: NgbModal, private pdlService: PDLService) {
    this.isModalOpen = false;
      this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      container: '#am-container-custom'
      }
  }
  openModal(config?,alertModal?): ModalPromise {
    if(alertModal){
      this.pdlService.ifEnabledGenerateModalViewTag({
        eventAction: ANALYTICS.LOAD,
        modalName:config.data.title,
        alert: [{
          "type":ANALYTICS.ACCOUNT_ALERT ,
          "name": config.data?.message,
          "code": '' 
        }]
      });
    }else{
      this.pdlService.ifEnabledGenerateModalViewTag({
        eventAction: ANALYTICS.LOAD,
        eventType: ANALYTICS.ERRORMODAL,    
        modalName:config.data.title,
        error: [{
          errorText: config.data.message,
          errorCode: ''
        }]
      });
    }
    const dataOpt: AlertConfigData = {
      title: 'ALert Dailog',
      message: 'message here',
      btnOk: true,
      btnNo: true,
      isCloseBtn: false,
      isErrorIcon: true,
      btnOkText: 'Ok',
      btnNoText: 'No',
      iconType: '',
    };
    
    const obj = {
      data:dataOpt
    }

    if (config) {
      Object.assign(obj.data, config.data);
    }

    const promise = new ModalPromise();
    if (!this.isModalOpen) {
      const alertConfirmPopupRef = this.modalService.open(AlertConfirmPopupComponent, this.ngbModalOptions);
      alertConfirmPopupRef.componentInstance.title = obj.data.title;
      alertConfirmPopupRef.componentInstance.message = obj.data.message;
      alertConfirmPopupRef.componentInstance.btnOkText = obj.data.btnOkText;
      this.isModalOpen = true;
    }

    return promise;
  }

}
